import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';

const MarkdownWithMath = ({ content, ...props }) => {
  if (!content) return null;

  // Combine plugins to support both Math and other markdown features like GFM
  const remarkPlugins = [remarkMath, ...(props.remarkPlugins || [])];
  const rehypePlugins = [rehypeKatex, ...(props.rehypePlugins || [])];

  return (
    <div className="markdown-math">
      <ReactMarkdown
        {...props}
        remarkPlugins={remarkPlugins}
        rehypePlugins={rehypePlugins}
      >
        {content}
      </ReactMarkdown>
      <style jsx global>{`
        .markdown-math {
          color: #333; /* Use a dark color for good contrast on light backgrounds */
          line-height: 1.6;
        }

        .markdown-math .katex-display {
          overflow-x: auto;
          overflow-y: hidden;
          padding: 0.5em 0;
        }

        .markdown-math .katex {
          font-size: 1.1em;
        }
        
        /* This ensures that if the app is in dark mode, the text will be readable */
        body.dark .markdown-math {
             color: #e5e7eb; /* light gray for dark mode */
        }
      `}</style>
    </div>
  );
};

export default MarkdownWithMath;